// extracted by mini-css-extract-plugin
export default {"tableContainer":"Table_tableContainer__Fbu-g"};